<template>
    <div v-if="doctorMenu !== null">
        <b-modal
            size="lg"
            v-model="modalShow"
            :title="`メニューの${afterToggleStatus}`"
            @hidden="close">
            <div class="jumbotron pt-3 pb-3">
                <p class="mb-0">{{ $locale.consultation_host }}科：{{ doctorMenu.medical_course.name }}</p>
                <p class="mb-0">タイトル：{{ doctorMenu.title }}</p>
                <p class="mb-0">{{ $locale.consultation_host }}時間：{{ doctorMenu.consultation_minutes }}分</p>
                <p class="mb-0">{{ $locale.consultation_host }}料：{{ doctorMenu.consultation_price.toLocaleString() }}円</p>
            </div>
            <p class="text-center">上記のメニューを{{ afterToggleStatus }}します。よろしいですか？</p>
            <div
                slot="modal-footer"
                class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-yokumiru-orange float-right"
                    :disabled="inProgress"
                    @click="deleteDoctorMenu">
                    {{ afterToggleStatus }}する
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                doctorMenu: null,
            }
        },

        computed: {
            isPublished: function () {
                if (!this.doctorMenu) return false

                return this.doctorMenu.status === constants.doctor_menus.published
            },

            afterToggleStatus: function () {
                return this.isPublished ? '公開停止' : '公開'
            },

            afterToggleStatusEndpoint: function () {
                return this.isPublished ? 'unpublish' : 'publish'
            },
        },

        created: function () {
            bus.$on('open-modal-admin-toggle-status-doctor-menu', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-toggle-status-doctor-menu')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {object} doctorMenu
             */
            open: function (doctorMenu) {
                this.doctorMenu = { ...doctorMenu }
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * 医師メニュー削除
             */
            deleteDoctorMenu: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.admin.doctor_menus.endpoint.base

                await axios.put(`${endpoint}/${this.doctorMenu.id}/${this.afterToggleStatusEndpoint}`)
                    .then(() => {
                        bus.$emit('alert-success', `メニューを${this.afterToggleStatus}しました。`)
                        bus.$emit('fetch-doctor-menus')
                        this.errors = {}
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },
        },
    }
</script>
